import(/* webpackMode: "eager" */ "/Users/christophkranebitter/renehuemer.com/website/src/app/art/[slug]/error.tsx");
